import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { decompress } from 'lz-string';
import { Subject, BehaviorSubject, distinctUntilChanged, takeUntil, combineLatest, map, take, startWith } from 'rxjs';
import { AgentSalesBizoimClientReponse, Bizoim, BizoimClient, BizoimClientResponse, BizoimConcentrated, BizoimConcentratedClients } from 'src/app/Interfaces/agent-sales-quantities';

import { StoreService } from 'src/app/services/store.service';
import { UtilService } from 'src/app/services/util.service';
import { ResponseFromExpress } from 'src/app/Interfaces/SQL-interfaces';
import { TDashDocSub } from 'src/app/Interfaces/reports';
import { translateDateForSQLServer } from 'src/app/Utility/date_functions/SQL_ISO_adapter';
import { MismachimEach } from '@interfaces/mismachim';
import { HTTP_CODES } from '@utils/constants-http';

const date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0);

@Component({
	selector: 'app-agent-sales-products-quantities-dates',
	templateUrl: './agent-sales-products-quantities-dates.component.html',
	styleUrls: ['./agent-sales-products-quantities-dates.component.scss'],
})
export class AgentSalesProductsQuantitiesDatesComponent implements OnInit, OnDestroy {
	private _ss = inject(StoreService);
	private router = inject(Router);
	private fb = inject(FormBuilder);

	constructor() {}

	dates = {
		min: (() => {
			const d = new Date();
			d.setFullYear(d.getFullYear() - 3);
			return d;
		})(),
		max: new Date(),
	};

	form = this.fb.group({
		SearchProduct: [''],
		SearchClient: [''],
		from: [new Date(date), Validators.required],
		to: [new Date(date), Validators.required],
		Agent: [null],
	});

	mustPickDatePopup = true;
	hasPickedAtLeastOnce = false;
	isMismachimPopupShowing = false;
	loadingMismachim = false;
	mismachim: MismachimEach[] = [];

	AllProducts;
	AllProductsSearch;
	Bizoim: Bizoim[] = [];
	Bizoim$ = new BehaviorSubject<Bizoim[]>(this.Bizoim);
	BizoimClients: BizoimClientResponse[] = [];
	BizoimClients$ = new BehaviorSubject<BizoimClient[]>([]);
	BizoimClientsDisplay$ = combineLatest([this.BizoimClients$, this.form.controls.SearchClient.valueChanges.pipe(startWith(''))]).pipe(
		map(([clients, search]) => {
			let grouped = Object.values<BizoimClient>(
				clients.reduce((acc, curr) => {
					acc[curr.ClientId + (curr.AgentId || '')] ||= {
						ClientId: curr.ClientId,
						Client_Name: curr.Client_Name,
						totqty: 0,
						totsum: 0,
						AgentId: curr.AgentId || '',
					};

					if (!curr.AgentId) {
						delete acc[curr.ClientId + (curr.AgentId || '')].AgentId;
					}

					acc[curr.ClientId + (curr.AgentId || '')].totqty += curr.totqty;
					acc[curr.ClientId + (curr.AgentId || '')].totsum += curr.totsum;

					return acc;
				}, {} as Record<string, BizoimClient>),
			);

			const searchValue = search?.toLowerCase().trim();

			if (searchValue?.length) {
				grouped = grouped.filter(c => c.Client_Name.toLowerCase().includes(searchValue) || c.ClientId.toLowerCase().includes(searchValue));
			}

			return grouped;
		}),
		map(clients => clients.map(c => ({ ...c, AvgPrice: c.totsum / c.totqty }))),
	);
	BizoimTeudot$ = new BehaviorSubject<TDashDocSub[]>([]);

	BizoimConcentrated: BizoimConcentrated[] = [];
	BizoimConcentrated$ = new BehaviorSubject<BizoimConcentrated[]>(this.BizoimConcentrated);
	BizoimConcentratedClients$ = new BehaviorSubject<BizoimConcentratedClients[]>([]);

	BizoimCompany;

	clientChosen: BizoimClient | null = null;

	toogleInputNew = false;
	ShowCompanys = null;
	HasMultipleCompanys;
	reportSearch = null;
	history = history;

	destroy$ = new Subject<void>();

	bizoimTotalQuantity$ = new BehaviorSubject<number>(0);
	bizoimTotalSum$ = new BehaviorSubject<number>(0);
	bizoimAverageSum$ = new BehaviorSubject<number>(0);

	loadingMainQuery = false;
	loadingRequest = false;

	windowWidth: number;

	isAdmin = location.pathname.includes('admin');

	AgentArray = [];

	loadingAgents = false;

	hasGetAgentSalesNextQuery = false;
	hasGetAgentOrdersNextQuery = false;
	hasGetAgentSalesNextQueryConcentrated = false;

	First = true;
	FirstScrollY = 0;
	Second = false;
	Third = false;

	shouldSecondTableShow$ = combineLatest([this.BizoimClients$, this.BizoimConcentratedClients$]).pipe(map(([clients, concentratedClients]) => !!(clients.length || concentratedClients.length)));

	isConcentrated = location.pathname.includes('concentrated');

	isOrders = location.pathname.includes('orders');

	agentsToGet = [];

	BizoimTeudotDisplay$ = combineLatest([this.BizoimTeudot$, this.form.valueChanges]).pipe(
		map(([teudot, form]) => {
			let { from, to } = form;

			if (this.isOrders) return teudot;

			from = translateDateForSQLServer(from);
			to = translateDateForSQLServer(to);
			to.setDate(to.getDate() + 1);

			return teudot.filter(t => {
				const date = new Date('20' + t.date1.split('-').reverse().join('-'));
				return date >= from && date <= to;
			});
		}),
	);

	productIDChosen = '';
	clientIDChosen = '';

	ngOnInit(): void {
		combineLatest([this.BizoimTeudotDisplay$, this.bizoimTotalSum$])
			.pipe(takeUntil(this.destroy$))
			.subscribe(([teudot, totalSum]) => {
				if (this.Third) this.bizoimAverageSum$.next(teudot.length ? totalSum / teudot.length : 0);
			});
		// this.BizoimTeudotDisplay$.pipe(takeUntil(this.destroy$)).subscribe(({ length }) => {

		// 	this.bizoimAverageSum$.next(length ? this.bizoimTotalSum$.value / length : 0);
		// });

		//////////////////// ---------- CLIENT INFORMATION ---------- ////////////////////
		if (this._ss.CustomerInformation === null) {
			if (localStorage.getItem('CustomerInformation') !== null) {
				this._ss.CustomerInformation = decompress(localStorage.getItem('CustomerInformation'));
				this._ss.CustomerInformation = JSON.parse(this._ss.CustomerInformation);
			}
		}
		//////////////////// ---------- CLIENT INFORMATION ---------- ////////////////////

		this.HasMultipleCompanys = localStorage.getItem('HasMultipleCompanys');

		this.windowWidth = window.innerWidth;

		if (this.HasMultipleCompanys === '2') {
			if (localStorage.getItem('ShowCompanys') !== null) {
				this.ShowCompanys = localStorage.getItem('ShowCompanys');
				this.ShowCompanys = JSON.parse(this.ShowCompanys);
			} else {
				this._ss.GetComppanys().subscribe(res => {
					this.ShowCompanys = res;
					this.ShowCompanys = this.ShowCompanys.recordset;
					localStorage.setItem('ShowCompanys', JSON.stringify(this.ShowCompanys));
				});
			}
		}

		const queries = [
			fetch(`${this._ss.CustomerInformation.CustServer}/mobil/reports/get-agent-sales/0`),
			fetch(`${this._ss.CustomerInformation.CustServer}/mobil/reports/get-agent-orders/0`),
			fetch(`${this._ss.CustomerInformation.CustServer}/mobil/reports/get-concentrated-sales-per-agents/test?checkIfExistsInIndex=true`),
		];

		Promise.allSettled(queries)
			.then(([getAgentSales, getAgentSalesOrders, getConcentratedSales]) => {
				if (getAgentSales.status === 'fulfilled' && getAgentSales.value.status !== HTTP_CODES.BAD_REQUEST.NOT_FOUND) {
					getAgentSales.value
						.json()
						.then(bod => {
							if (bod.msg) {
								this.hasGetAgentSalesNextQuery = true;
							}
						})
						.catch(err => console.log(err));
				}

				if (getAgentSalesOrders.status === 'fulfilled' && getAgentSalesOrders.value.status !== HTTP_CODES.BAD_REQUEST.NOT_FOUND) {
					getAgentSalesOrders.value
						.json()
						.then(bod => {
							if (bod.msg) {
								this.hasGetAgentOrdersNextQuery = true;
							}
						})
						.catch(err => console.log(err));
				}
				if (getConcentratedSales.status === 'fulfilled' && getConcentratedSales.value.status !== HTTP_CODES.BAD_REQUEST.NOT_FOUND) {
					if (getConcentratedSales.value.ok) {
						this.hasGetAgentSalesNextQueryConcentrated = true;
					}
				}
			})
			.catch(err => {
				console.log(err);
			});

		if (this.isAdmin) {
			this.loadingAgents = true;

			this.getAgents();
		}

		window.scrollTo(0, 0);

		if (!localStorage.getItem('UserName') && !localStorage.getItem('AgentId')) {
			this.router.navigate(['login']);
		}

		this._ss.UserNameConnected = localStorage.getItem('UserName');
		this._ss.AgentIdConnected = localStorage.getItem('AgentId');

		this.form.controls.SearchProduct.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(val => {
			if (val) {
				const splitValue = val.split(' ').map(v => v.toLowerCase());
				const arr = [];

				for (let i = 0; i < this.Bizoim.length; i++) {
					let counter = 0;

					const { ProductId, Product_Name } = this.Bizoim[i];

					const ProductIdWithoutSpaces = (ProductId || '').replace(/\s/g, '').toLowerCase(),
						Product_NameWithoutSpaces = (Product_Name || '').replace(/\s/g, '').toLowerCase(),
						allStrings = typeof ProductIdWithoutSpaces === 'string' && typeof Product_NameWithoutSpaces === 'string';

					// V8 optimizes this if statement, maybe
					if (allStrings) {
						for (let j = 0; j < splitValue.length; j++) {
							if ((ProductIdWithoutSpaces && ProductIdWithoutSpaces.indexOf(splitValue[j]) > -1) || (Product_NameWithoutSpaces && Product_NameWithoutSpaces.indexOf(splitValue[j]) > -1)) {
								counter++;
							}
						}
					}

					if (counter === splitValue.length) {
						arr.push(this.Bizoim[i]);
					}
				}

				this.Bizoim$.next(arr);
				this.refreshSubjects('Bizoim');
				return;
			}

			this.Bizoim$.next(this.Bizoim);
			this.refreshSubjects('Bizoim');
		});
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	handleClosePopup() {
		this.mustPickDatePopup = false;
		if (!this.hasPickedAtLeastOnce) {
			history.back();
			return;
		}
	}

	handleFormSubmit() {
		this.loadingMainQuery = this.loadingRequest = true;

		let { from, to, Agent } = this.form.value;

		let toAdd = [];

		if (!this.isAdmin) {
			toAdd.push(this._ss.AgentIdConnected);
		}

		if (this.isAdmin && Agent && Agent.length) {
			toAdd = [Agent, true];
		}

		from = new Date(Intl.DateTimeFormat('en-il', {}).format(new Date(+from)).split('/').reverse().join('/'));
		to = new Date(Intl.DateTimeFormat('en-il', {}).format(new Date(+to)).split('/').reverse().join('/'));

		from = translateDateForSQLServer(from);
		to = translateDateForSQLServer(to);

		// if (from.getTime() === to.getTime()) {
		to.setHours(24 - new Date().getTimezoneOffset() / 60);
		// }

		if (this.isOrders) {
			this._ss.getAgentSalesOrderssQuantitiesDates(from, to, ...toAdd).subscribe({
				next: (res: ResponseFromExpress<Bizoim>) => {
					if (res === 'ConnectionError' || res === 'RequestError') {
						this.handleError();
						return;
					}

					this.Bizoim = res.recordset;

					this.Bizoim$.next(this.Bizoim);

					this.mustPickDatePopup = false;
					this.hasPickedAtLeastOnce = true;

					this.refreshSubjects('Bizoim');

					this.loadingMainQuery = this.loadingRequest = false;

					this.form.controls.SearchProduct.setValue(this.form.controls.SearchProduct.value);
				},
				error: err => {
					this.handleError();
				},
			});
			return;
		}

		if (this.isConcentrated) {
			this._ss
				.getAgentSalesProductsQuantitiesDatesConcentrated(from, to, ...toAdd)
				.pipe(takeUntil(this.destroy$))
				.subscribe({
					next: (res: ResponseFromExpress<BizoimConcentrated>) => {
						if (res === 'ConnectionError' || res === 'RequestError') {
							this.handleError();
							return;
						}

						this.BizoimConcentrated = res.recordset;

						this.BizoimConcentrated$.next(this.BizoimConcentrated);

						this.mustPickDatePopup = false;
						this.hasPickedAtLeastOnce = true;

						this.refreshSubjects('BizoimConcentrated');

						this.loadingMainQuery = this.loadingRequest = false;

						this.form.controls.SearchProduct.setValue(this.form.controls.SearchProduct.value);
					},
					error: err => {
						this.handleError();
					},
				});
			return;
		}

		this._ss.getAgentSalesProductsQuantitiesDates(from, to, ...toAdd).subscribe({
			next: (res: ResponseFromExpress<Bizoim>) => {
				if (res === 'ConnectionError' || res === 'RequestError') {
					this.handleError();
					return;
				}

				this.Bizoim = res.recordset;

				this.Bizoim$.next(this.Bizoim);

				this.mustPickDatePopup = false;
				this.hasPickedAtLeastOnce = true;

				this.refreshSubjects('Bizoim');

				this.loadingMainQuery = this.loadingRequest = false;

				this.form.controls.SearchProduct.setValue(this.form.controls.SearchProduct.value);
			},
			error: err => {
				this.handleError();
			},
		});
	}

	handleError() {
		alert('ישנה תקלת תקשורת, אנא נסה שנית מאוחר יותר');
		this.history.back();
		return;
	}

	changeDateValue(val: 'month' | 'year') {
		const { from, to } = this.form.value;

		if (val === 'month') {
			from.setMonth(from.getMonth() - 1);
		} else {
			from.setFullYear(from.getFullYear() - 1);
		}

		this.form.patchValue({ from, to });
	}

	SearchClear() {
		if (this.First) {
			this.form.controls.SearchProduct.reset();
			this.refreshSubjects('Bizoim');
		}
		if (this.Second) {
			this.form.controls.SearchClient.reset();
			this.refreshSubjects('BizoimClients');
		}

		this.clearEverything();
	}

	//TODO refactor into two different methods

	clearEverything() {
		// this.Bizoim$.next(this.Bizoim);
		// this.refreshSubjects('Bizoim');
	}

	// public ChangeCompany() {
	// 	this.Bizoim = [];

	// 	for (let x = 0; x < this.BizoimCompany.length; x++) {
	// 		if (this.BizoimCompany[x].COMPANY === JSON.parse(this.form.controls.Company.value)) {
	// 			this.Bizoim.push(this.BizoimCompany[x]);
	// 		}
	// 	}
	// }

	compareProductWithClients(productidOrClientID: string) {
		if (this.loadingRequest) return;
		if (this.isOrders && !this.hasGetAgentOrdersNextQuery) return;
		if (this.isConcentrated && !this.hasGetAgentSalesNextQueryConcentrated) return;
		if (!this.isOrders && !this.isConcentrated && !this.hasGetAgentSalesNextQuery) return;

		this.loadingMainQuery = this.loadingRequest = true;

		this.productIDChosen = productidOrClientID;
		if (this.isConcentrated) {
			this.clientIDChosen = productidOrClientID;
		}

		this.FirstScrollY = window.scrollY;

		let { from, to, Agent } = this.form.value;

		// if (from.getDate() === to.getDate() && from.getMonth() === to.getMonth() && from.getFullYear() === to.getFullYear()) {
		// }

		from = translateDateForSQLServer(from);
		to = translateDateForSQLServer(to);

		to.setDate(to.getDate() + 1);

		let toAdd = [];

		if (!this.isAdmin) {
			toAdd.push(this._ss.AgentIdConnected);
		}

		if (this.isAdmin && Agent && Agent.length) {
			toAdd = [Agent, true];
		}

		if (this.isOrders) {
			this._ss.getAgentSalesOrdersProductsQuantitiesDatesSpecificProduct(productidOrClientID, from, to, ...toAdd).subscribe({
				next: res => {
					if (res === 'ConnectionError' || res === 'RequestError') {
						console.log('Error:', res);
						return;
					}

					this.BizoimClients = res.recordset;

					this.BizoimClients$.next(
						res.recordset.map(rcd => ({ ...rcd, Client_Name: rcd.Client_Name, ClientId: rcd.ClientId, totqty: rcd.DocQuantity || rcd.totqty, totsum: rcd.DocPrice || rcd.totsum })),
					);
					this.Second = true;
					this.First = false;
					window.scrollTo(0, 0);

					this.refreshSubjects('BizoimClients');

					this.loadingMainQuery = this.loadingRequest = false;
				},
				error: err => {
					console.log(err);
					this.loadingMainQuery = this.loadingRequest = false;
				},
			});
			return;
		}

		if (this.isConcentrated) {
			let agents = [];
			let groupAgents = false;
			if (!this.isAdmin) {
				agents.push(this._ss.AgentIdConnected);
			} else if (Agent?.length) {
				agents = Agent;
				groupAgents = true;
			}

			this._ss.getAgentSalesProductsQuantitiesDatesConcentratedByProduct(productidOrClientID, { from, to, agents, groupAgents }).subscribe({
				next: res => {
					if (res === 'ConnectionError' || res === 'RequestError') {
						console.log('Error:', res);
						return;
					}

					this.BizoimConcentratedClients$.next(res.recordset);

					// this.BizoimClients$.next(
					// 	res.recordset.map(rcd => ({ ...rcd, Client_Name: rcd.Client_Name, ClientId: rcd.ClientId, totqty: rcd.DocQuantity || rcd.totqty, totsum: rcd.DocPrice || rcd.totsum })),
					// );
					this.Second = true;
					this.First = false;
					window.scrollTo(0, 0);

					this.refreshSubjects('BizoimConcentratedClients');

					this.loadingMainQuery = this.loadingRequest = false;
				},
				error: err => {
					console.log(err);
					this.loadingMainQuery = this.loadingRequest = false;
				},
			});
			return;
		}

		this._ss.getAgentSalesProductsQuantitiesDatesSpecificProduct(productidOrClientID, from, to, ...toAdd).subscribe({
			next: res => {
				if (res === 'ConnectionError' || res === 'RequestError') {
					console.log('Error:', res);
					return;
				}

				this.BizoimClients = res.recordset;

				console.log(this.BizoimClients);

				this.BizoimClients$.next(
					res.recordset.map(rcd => ({ ...rcd, Client_Name: rcd.Client_Name, ClientId: rcd.ClientId, totqty: rcd.DocQuantity || rcd.totqty, totsum: rcd.DocPrice || rcd.totsum })),
				);
				this.Second = true;
				this.First = false;
				window.scrollTo(0, 0);

				this.refreshSubjects('BizoimClients');

				this.loadingMainQuery = this.loadingRequest = false;
			},
			error: err => {
				console.log(err);
				this.loadingMainQuery = this.loadingRequest = false;
			},
		});
	}

	handleNavigation() {
		if (this.First) {
			history.back();
			return;
		}

		if (this.Second) {
			this.Second = false;
			this.First = true;
			this.BizoimClients$.next([]);
			this.form.controls.SearchClient.reset();
			this.refreshSubjects('Bizoim');
			setTimeout(() => {
				window.scrollTo(0, this.FirstScrollY);
			}, 0);
			return;
		}

		if (this.Third) {
			this.Third = false;
			this.Second = true;
			this.refreshSubjects('BizoimClients');
			this.BizoimTeudot$.next([]);
			this.clientChosen = null;
			return;
		}
	}

	getTeudotOfClient(client: BizoimClient, totSum: number, totQty?: number) {
		if (this.isConcentrated || this.form.controls.Agent.value?.length || this.loadingRequest) return;

		const { ClientId } = client;

		if (this.isOrders) {
			if (!this.hasGetAgentOrdersNextQuery) return;

			let agents;
			this.loadingRequest = true;

			if (this.isAdmin && this.form.controls.Agent.value?.length) {
				agents = this.form.controls.Agent.value;
			}

			let { from, to } = this.form.value;

			from = translateDateForSQLServer(from);
			to = translateDateForSQLServer(to);

			to.setDate(to.getDate() + 1);

			this._ss.getAgentSalesOrdersProductsQuantitiesDatesSpecificProductSpecificClient(this.productIDChosen, ClientId, from, to, agents).subscribe({
				next: res => {
					this.loadingRequest = false;
					if (res === 'ConnectionError' || res === 'RequestError') {
						alert('שגיאה בקבלת נתונים');
						return;
					}

					this.clientChosen = client;

					if (!res.recordset.length) {
						alert('לא נמצאו תעודות עבור לקוח זה');
						return;
					}

					this.BizoimTeudot$.next(res.recordset);
					this.Third = true;
					this.Second = false;

					// this.refreshSubjects('BizoimTeudot');
					this.bizoimTotalSum$.next(totSum);
					if (totQty != null) {
						this.bizoimTotalQuantity$.next(totQty);
					}
				},
				error: err => {
					this.loadingRequest = false;
					alert('שגיאה בקבלת נתונים');
				},
			});
			return;
		}

		this.loadingRequest = true;

		this._ss.GetProductTeudaService(this.productIDChosen, ClientId).subscribe({
			next: res => {
				this.loadingRequest = false;
				if (typeof res === 'string') {
					alert('לא ניתן לקבל תעודות עבור לקוח זה כרגע');
					return;
				}

				if (!res.recordset.length) {
					alert('לא נמצאו תעודות עבור לקוח זה');
					return;
				}

				this.clientChosen = client;

				this.BizoimTeudot$.next(res.recordset);
				this.Third = true;
				this.Second = false;
				this.bizoimTotalSum$.next(totSum);

				if (totQty != null) {
					this.bizoimTotalQuantity$.next(totQty);
				}
			},
			error: err => {
				this.loadingRequest = false;
				alert('שגיאה בקבלת נתונים');
			},
		});
	}

	async getAgents(): Promise<void> {
		if (this._ss.CustomerInformation.Submanagers === '1') {
			this.agentsToGet = await this.getSubmanagerAgentsFirst();
		}

		this.getAgentUsers();
	}

	async getSubmanagerAgentsFirst(): Promise<string[]> {
		return await new Promise(resolve => {
			if (!this._ss.agentsOfSubmanager.length) {
				this._ss.getAdminAgents().subscribe({
					next: res => {
						if (typeof res === 'string') {
							alert('חלה תקלה בהבאת סוכנים עבור מנהל זה. נסו שנית');
							resolve([]);
							history.back();
							return;
						}

						const agents = res.recordset.map(obj => obj.Agent);
						agents.push(this._ss.AgentIdConnected);
						this._ss.agentsOfSubmanager = agents;

						return resolve(agents);
					},
					error: err => {
						alert('שגיאת שרת');
					},
				});
			} else {
				resolve(this._ss.agentsOfSubmanager);
			}
		});
	}

	getAgentUsers() {
		this._ss.GetAllAgents(this.agentsToGet).subscribe({
			next: res => {
				if (res === 'ConnectionError' || res === 'RequestError') {
					alert('אירעה שגיאה בקבלת נתונים מהשרת, אנא נסה שנית');
					history.back();
					return;
				}

				this.AgentArray = res.recordset;
				this.loadingAgents = false;
			},
			error: err => {
				alert('אירעה שגיאה בקבלת נתונים מהשרת, אנא נסה שנית');
				history.back();
			},
		});
	}

	refreshSubjects(mode: 'Bizoim' | 'BizoimClients' | 'BizoimConcentrated' | 'BizoimConcentratedClients' | 'BizoimTeudot') {
		if (this.isConcentrated) {
			mode = 'BizoimConcentrated';
		}

		switch (mode) {
			case 'Bizoim':
				this.bizoimTotalQuantity$.next(this.Bizoim$.value.length ? this.Bizoim$.value.reduce((p, c) => p + c.totqty, 0) : 0);
				this.bizoimTotalSum$.next(this.Bizoim$.value.length ? this.Bizoim$.value.reduce((p, c) => p + c.totsum, 0) : 0);
				this.bizoimAverageSum$.next(this.Bizoim$.value.length ? this.Bizoim$.value.reduce((p, c) => p + c.totsum, 0) / this.Bizoim$.value.length : 0);
				break;
			case 'BizoimClients':
				this.bizoimTotalQuantity$.next(this.BizoimClients$.value.length ? this.BizoimClients$.value.reduce((p, c) => p + c.totqty, 0) : 0);
				this.bizoimTotalSum$.next(this.BizoimClients$.value.length ? this.BizoimClients$.value.reduce((p, c) => p + c.totsum, 0) : 0);
				this.bizoimAverageSum$.next(this.BizoimClients$.value.length ? this.BizoimClients$.value.reduce((p, c) => p + c.totsum, 0) / this.BizoimClients$.value.length : 0);
				break;
			case 'BizoimConcentrated':
				this.bizoimTotalSum$.next(this.BizoimConcentrated$.getValue().length ? this.BizoimConcentrated$.value.reduce((p, c) => p + (+c.totavg || 0), 0) : 0);
				this.bizoimAverageSum$.next(this.BizoimConcentrated$.value.length ? this.BizoimConcentrated$.value.reduce((p, c) => p + (+c.AvgPrice || 0), 0) / this.BizoimConcentrated$.value.length : 0);
				break;
			case 'BizoimConcentratedClients':
				this.bizoimTotalSum$.next(this.BizoimConcentratedClients$.getValue().length ? this.BizoimConcentratedClients$.value.reduce((p, c) => p + (+c.totavg || 0), 0) : 0);
				this.bizoimAverageSum$.next(
					this.BizoimConcentratedClients$.value.length ? this.BizoimConcentratedClients$.value.reduce((p, c) => p + (+c.AvgPrice || 0), 0) / this.BizoimConcentrated$.value.length : 0,
				);
				break;

			case 'BizoimTeudot':
				// this.bizoimTotalSum$.next(this.BizoimTeudot$.value.length ? this.BizoimTeudot$.value.reduce((p, c) => p + c.prc, 0) : 0);
				break;

			default:
				break;
		}
	}

	sortArr = [false, false, false, false];

	sort(valueToSortBy: string, arrayToSort: string) {
		const opt: Intl.CollatorOptions = { numeric: true, sensitivity: 'base' };

		let bool: boolean, i: number;

		let arrOverride: Bizoim[] | BizoimClient[];

		// if (this.form.controls.SearchProduct.value) {
		if (this.First) arrOverride = this.Bizoim$.getValue();
		if (this.Second) arrOverride = this.BizoimClients$.getValue();
		// }

		switch (valueToSortBy) {
			case 'ProductId':
			case 'ClientId':
				i = 0;
				break;
			case 'Product_Name':
			case 'Client_Name':
				i = 1;
				break;
			case 'totqty':
				i = 2;
				break;
			case 'totsum':
				i = 3;
				break;

			default:
				console.log('I should never return');
				return;
		}
		bool = this.sortArr[i];
		this.sortArr = this.sortArr.map(_ => false);

		this.sortArr[0] = bool;

		const finalArr = arrOverride || this[arrayToSort];

		if (bool) {
			finalArr.sort((a, b) => new Intl.Collator('he', opt).compare(b[String(valueToSortBy)], a[String(valueToSortBy)]));
		} else {
			finalArr.sort((a, b) => new Intl.Collator('he', opt).compare(a[String(valueToSortBy)], b[String(valueToSortBy)]));
		}

		if (this.First) this.Bizoim$.next(finalArr);

		if (this.Second) this.BizoimClients$.next(finalArr);

		this.sortArr[i] = !bool;
	}

	closeMismachimPopup() {
		this.isMismachimPopupShowing = false;
		this.mismachim = [];
	}

	openMismachimPopup(teudaNum: string) {
		this.isMismachimPopupShowing = true;
		this.loadingMismachim = true;
		const client = (this.BizoimClients as unknown as AgentSalesBizoimClientReponse[]).find(c => (c.DocNum || '').split('-')[0] === teudaNum);
		if (!client) {
			this.loadingMismachim = false;
			return;
		}
		const { DocNum: DocDocNum, doctype: DocType } = client;
		let docnum = DocDocNum.split('-')[0];
		this._ss.GetOneTeudaAgentNew({ DocDocNum: docnum, DocDocType: String(DocType) }, 1).subscribe({
			next: (res: any) => {
				this.loadingMismachim = false;
				if (typeof res === 'string') {
					return;
				}

				this.mismachim = res.recordset;
				setTimeout(() => {
					// this.rightSideOfTableHistoriyaOrDohotPopupTable.nativeElement.scrollIntoView();
				}, 10);
			},
			error: () => {
				this.loadingMismachim = false;
			},
		});
	}
}
